// extracted by mini-css-extract-plugin
module.exports = {"panel":"index-panel-3GZ2H","close":"index-close-3xmSa","confirm":"index-confirm-3uwHs","bound":"index-bound-UBU_B"};